<template>
  <!--设备数据呈现-->
  <div class="el-tabs__content">
    <h1 style="height:37px">
      采集点数据
      <el-button size="small" @click="refresh" icon="el-icon-refresh"></el-button>
      <el-checkbox v-model="deviceDataIsFlush" @change="deviceDataFlush">自动刷新
        <el-button size="small" @click="dialogVisible = true" icon="el-icon-download">导出</el-button>
      </el-checkbox>
      <el-radio-group v-model="displayMode" class="fr displayMode">
        <!--                <el-radio-button label="card">卡片</el-radio-button>-->
        <!-- <el-radio-button label="list">列表</el-radio-button> -->
      </el-radio-group>
    </h1>
    <div v-if="pointData.length != 0">
      <!-- 卡片 -->
      <div v-if="displayMode == 'card'" class="displayModeCard">
        <el-row :gutter="12" style="margin: 0 0 50px;" v-for="(packet, index) in pointData" :key="index">
          <div style="font-size: 16px;font-weight: bold;">{{packet.packetName}}</div>
          <div v-if="packet.realTimeDataVos.length == 0">无数据</div>
          <el-col :span="6" v-for="(item, index) in packet.realTimeDataVos" :key="index">
            <el-card shadow="always">
              <i :title="item.value" class="skipDiscount" @click="pointDatadetailBtn(item,packet.packetCode)"></i>
              <!-- 弹出折线图 -->
              <p style="margin-bottom:0">{{ item.name }}{{item.dataUnit ? '（'+item.dataUnit+'）' : ''}}</p>
              <div class="colGreen">{{ item.value }}</div>

              <p>{{ dateformat(item.timestamp) }}</p>
            </el-card>
          </el-col>
        </el-row>

      </div>
      <!-- 列表 -->
      <el-table v-if="displayMode == 'list'" :data="pointData" height="450px">
        <el-table-column prop="name" label="名称">
          <template slot-scope="scope">
            <el-button class="tableButton" @click="pointDatadetailBtn(scope.row)">
              {{ scope.row.name }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="value" label="当前值">
        </el-table-column>
        <el-table-column prop="dataUnit" label="单位">
        </el-table-column>
        <el-table-column prop="timestamp" label="最近采集时间">
          <template slot-scope="scope">
            {{ dateformat(scope.row.timestamp) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 无数据显示 -->
    <div v-if="pointData.length == 0">
      <p>暂无数据。</p>
    </div>
    <!-- 历史数据折线图 -->
    <el-dialog :title="'（'+(this.fieldItem ? this.fieldItem.name :'') + '）历史数据'" :visible.sync="historicalDatadialog"
      width="80%" :close-on-click-modal='false' :append-to-body="true" :before-close="handleClose">
      <div style="height:30px;">
        <el-radio-group v-model="dialogDisplayMode" class="fr displayMode">
          <el-radio-button label="chart" :disabled="this.fieldItem.dataType != 1">图表</el-radio-button>
          <el-radio-button label="list">列表</el-radio-button>
        </el-radio-group>
        <el-date-picker v-model="date" type="datetimerange" :picker-options="pickerOptions" size="small"
          style="float:right;margin-right:20px" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm" :default-time="['00:00:00', '23:59:59']" @change="queryData">
        </el-date-picker>
        <el-checkbox style="float:right;margin-right:70px" v-model="isFlush" @change="chengeFlush">自动刷新</el-checkbox>
      </div>

      <div style="height:400px;">
        <!-- 默认显示曲线图 -->
        <span v-show="dialogDisplayMode == 'chart'">
          <div id="historicalData" ref="historicalData" style="height:100%;width:100%;display: inline-block;"></div>
        </span>
        <div v-show="dialogDisplayMode == 'list'" id="tableBox"
          style="display: inline-block;height:100%;width:100%;vertical-align: top;">
          <el-table v-loading="loading" ref="historyTable" height="400"
            :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" stripe fit empty-text="暂无数据">
            <el-table-column label="时间" min-width="100px">
              <template slot-scope="scope">
                {{ dateformat(scope.row.time) }}
              </template>
            </el-table-column>
            <el-table-column prop="value" label="值">
              <template slot-scope="scope">
                <div>{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination layout="prev, pager, next" :total="total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="canel">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog :append-to-body="true" title="导出设备历史数据" :visible.sync="dialogVisible" width="30%">
      <span>
        <el-form :model="exportForm">
          <el-form-item label="指标：">
            <el-select v-model="exportForm.fields" multiple placeholder="请选择" clearable>
              <el-option v-for="item in pointData" :key="item.packetCode+'-'+item.packetName" :label="item.packetName"
                :value="item.packetCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期：">
            <el-date-picker v-model="exportForm.dateRange" type="datetimerange" :picker-options="pickerOptionsExport"
              :value-format="'yyyy-MM-dd HH:mm:ss'" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              align="right">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportExcel">导 出</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<script>
  import ECHARTS from "echarts";
  import API from "../../api/api";
  import dayjs from "dayjs";
  export default {
    name: "device-data-show",
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        isFlush: false,
        deviceDataIsFlush: false, //设备数据自动刷新
        deviceDataInterval: null, //设备数据自动刷新定时器
        loading: false,
        pointData: [], //采集点数据
        displayMode: "card",
        historicalDatadialog: false, //历史数据
        chart: null,
        date: '',
        start: "",
        end: "",
        fieldItem: {},
        interval: null,
        tableData: [],
        pageSize: 10,
        currentPage: 1,
        dialogDisplayMode: 'chart',
        total: 0,
        dialogVisible: false,
        exportForm: {
          fields: [],
          dateRange: ['', '']
        },
        fieldList: [],
        pickerOptionsExport: {
          shortcuts: [{
              text: '最近1小时',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一天',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            },
          ],
          disabledDate: function (time) {
            return time.getTime() > Date.now()
          }
        },
      };
    },
    props: {
      deviceId: '', //父组件传过来的设备id参数
    },
    watch: {
      deviceId: {
        handler(newVal, oldVal) {
          this.getView();
          this.initTimeRange();
        },
        deep: true
      }
    },
    methods: {

      //初始化时间
      initTimeRange() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000);
        this.exportForm.dateRange = [start, end]

      },

      exportExcel() {

        if (!this.exportForm.dateRange || this.exportForm.dateRange.length < 2 || !this.exportForm.dateRange[1]) {
          this.$message.error("请选择时间");
          return;
        }
        if (this.exportForm.fields.length === 0) {
          this.$message.error("请输入指标");
          return;
        }

        let fieldArrayStr = ""
        this.exportForm.fields.forEach(field => {
          this.pointData.forEach(pdata => {
            if (pdata.packetCode == field) {
              fieldArrayStr += pdata.realTimeDataVos.map((v, k) => v.code + "-" + v.name).join(",")
              fieldArrayStr += ","
            }
          })
        })

        if (fieldArrayStr.length > 0) {
          fieldArrayStr = fieldArrayStr.substr(0, fieldArrayStr.length - 1)
        }


        this.dialogVisible = false
        let para = {
          deviceId: this.deviceId,
          fields: fieldArrayStr,
          startTime: dayjs(this.exportForm.dateRange[0]).format('YYYY-MM-DD HH:mm:ss'), //Unix 时间戳 (秒)
          endTime: dayjs(this.exportForm.dateRange[1]).format('YYYY-MM-DD HH:mm:ss'), //Unix 时间戳 (秒)
          access_token: this.$cookies.get('access_token')
        };
        window.open(API.exportDeviceHistoryDataUrl(para))
      },

      handleClose(done) {
        this.canel()
      },

      canel() {
        this.historicalDatadialog = false;
        this.isFlush = false
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
      },

      refresh() {
        this.getView();
      },
      dateformat(timestamp) {
        if (!timestamp) {
          return ''
        }
        return dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss")
      },

      getView() {
        //获取采集点数据
        API.platformDevDeviceGetrealtimedata({
          id: this.deviceId
        }).then(res => {
          if (res.code == 1) {
            this.pointData = res.data;
          }
        })
      },

      chengeFlush() {
        if (this.isFlush && this.interval == null) { //设置为定时刷新，并未启动定时器时，启动定时器
          this.interval = setInterval(this.queryData, 5000);
        } else if (!this.isFlush) { //设置为非定时刷新，关闭定时器
          clearInterval(this.interval);
          this.interval = null;
        }
      },

      // 设备定时刷新
      deviceDataFlush() {
        if (this.deviceDataIsFlush && this.deviceDataInterval == null) { //设置为定时刷新，并未启动定时器时，启动定时器
          this.deviceDataInterval = setInterval(this.refresh, 5000);
        } else if (!this.deviceDataIsFlush) { //设置为非定时刷新，关闭定时器
          clearInterval(this.deviceDataInterval);
          this.deviceDataInterval = null;
        }
      },
      queryData() {

        let para = {
          devId: this.deviceId,
          fieldCode: this.fieldItem.code,
          packetCode: this.fieldItem.packetCode,
          startDate: this.date[0],
          endDate: this.date[1]
        };


        API.platformDevDeviceDatelinedata(para).then(res => {
          if (res.code == 1) {

            let HistoricalTime = []; //时间
            res.data[0].forEach(element => {
              HistoricalTime.push(
                dayjs(new Date(element)).format("YYYY-MM-DD HH:mm:ss")
              );
            });

            let HistoricalData = res.data[1]; //数据

            //填充数据到列表
            let valueArr = []
            let len = HistoricalTime.length
            for (let i = len - 1; i >= 0; i--) {
              valueArr.push({
                time: HistoricalTime[i],
                value: HistoricalData[i]
              })
            }
            this.tableData = valueArr
            this.total = len


            if (this.fieldItem.dataType == 1) { //数值类型才展示图表
              setTimeout(() => {
                this.initChart(HistoricalTime, HistoricalData, this.fieldItem.name, this.fieldItem.dataUnit);
              }, 300);
            } else {
              this.dialogDisplayMode = 'list'
            }
          } else {
            this.$message.error(res.msg)
          }
        })

      },
      //采集点点击名称展开历史数据折线图
      pointDatadetailBtn(item, packetCode) {
        this.historicalDatadialog = true
        let dateStr = dayjs().format('YYYY-MM-DD');
        let startTime = dateStr + ' 00:00:00'
        let endTime = dateStr + ' 23:59:59'
        this.date = [startTime, endTime]
        item.packetCode = packetCode
        this.fieldItem = item
        this.queryData();
      },
      //历史数据折线图
      initChart(HistoricalTime, HistoricalData, fieldName, unit) {
        this.chart = ECHARTS.init(this.$refs.historicalData);

        let option = {
          tooltip: {
            trigger: "axis",
            position: function (pt) {
              return [pt[0], "10%"];
            }
          },
          grid: {
            left: 50,
            right: 50,
            top: "10%",
            bottom: 50
            // containLabel: true
          },

          //时间轴
          dataZoom: [{
              type: "inside",
              start: 0,
              end: 100
            },
            {
              start: 0,
              end: 100,
              handleIcon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
              handleSize: "80%",
              handleStyle: {
                color: "#fff",
                shadowBlur: 3,
                shadowColor: "rgba(0, 0, 0, 0.6)",
                shadowOffsetX: 2,
                shadowOffsetY: 2
              }
            }
          ],
          xAxis: [{
            type: "category",
            boundaryGap: false,
            data: HistoricalTime || null
          }],
          yAxis: [{
            name: fieldName + (unit ? "(" + unit + ")" : ''),
            type: "value",
            boundaryGap: false
          }],
          series: [{
            smooth: 0.3,
            symbol: 'circle', //设定为实心点
            symbolSize: 2.3, //设定实心点的大小
            color: '#4b8afd',
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1.0, //折线宽度
                  // color: '#337afc'
                }
              }
            },
            name: fieldName,
            type: "line",
            data: HistoricalData || null,
            markPoint: {
              symbol: 'pin',
              label: {
                fontSize: 10,
                formatter: function (param) {
                  if (param.data.type == 'max')
                    return "Max" + "\n" +
                      param.data.value + (unit ? unit : "");
                  if (param.data.type == 'min')
                    return "Min" + "\n" +
                      param.data.value + (unit ? unit : "");
                },
              },

              data: [{
                  type: 'max',
                  name: 'max'
                },
                {
                  type: 'min',
                  name: 'min'
                }
              ]
            },
          }]
        }

        this.chart.setOption(option);

      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      }
    },
    mounted() {
      this.getView();
      this.initTimeRange();
    },
    destroyed() {
      //组件销毁需要停止刷新
      this.deviceDataIsFlush = false;
      this.deviceDataFlush();
    }

  }

</script>



// WEBPACK FOOTER //
// src/components/device/deviceDataShow.vue